import { Action } from '@ngrx/store';
import { IIdentify } from 'src/app/models/identify.interface';

export enum EIdentifyActions {
  AddLanguage = '[Identify] Add Language',
  AddToken = '[Identify] Add Token',
  GetIdentify = '[Identify] Get Identify',
  GetIdentifySuccess = '[Identify] Get Identify Success'
}

export class GetIdentify implements Action {
  public readonly type = EIdentifyActions.GetIdentify;
}

export class GetIdentifySuccess implements Action {
  public readonly type = EIdentifyActions.GetIdentifySuccess;
  constructor(public payload: IIdentify) {}
}

export class AddToken implements Action {
  public readonly type = EIdentifyActions.AddToken;
  constructor(public payload: string) {}
}

export class AddLanguage implements Action {
  public readonly type = EIdentifyActions.AddLanguage;
  constructor(public payload: string) {}
}

export type IdentifyActions =
  | AddLanguage
  | AddToken
  | GetIdentify
  | GetIdentifySuccess;

